import {
  APPLICANT_REVEAL_IDENTITY_TRANSITION,
  APPLICANT_STAGE,
  APPLICANT_TRANSITION_ACTION,
} from '../../../RentalPortalApplicant'

export const QA_NAME_APPLICANT_PROFILE_STAGE_SELECT =
  'applicantProfileStageSelect'

export const QA_NAME_APPLICANT_PROFILE_STAGE_BADGE = 'applicantProfileStage'

export const QA_NAME_APPLICANT_MOVE_TO_SCREENING_CONFIRMATION =
  'applicantMoveToScreeningConfirmation'

export const APPLICANT_STAGE_FALLBACK_TEXT_COLOR = 'var(--secondary-text-color)'

export const APPLICANT_STAGE_TRANSITION = {
  [APPLICANT_STAGE.rejected]: {
    textKey: 'RentalPortal.ApplicantProfileStageRejectBtnKey',
  },
  [APPLICANT_STAGE.screening]: {
    textKey: 'RentalPortal.ApplicantProfileStageMoveToScreeningBtnKey',
  },
  [APPLICANT_STAGE.withdrawn]: {
    textKey: 'RentalPortal.ApplicantProfileStageWithdrawBtnKey',
  },
}

export const APPLICANT_STAGE_TRANSITION_AVAILABLE = [
  APPLICANT_STAGE.rejected,
  APPLICANT_STAGE.screening,
  APPLICANT_STAGE.withdrawn,
]

// TODO: mock applicants have no reject / withdraw write
export const APPLICANT_MOCK_STAGE_TRANSITION_AVAILABLE = [
  APPLICANT_STAGE.screening,
]

export const APPLICANT_MOVE_TO_SCREENING_TRANSITION = APPLICANT_STAGE.screening

export const APPLICANT_TRANSITION_NO_RIGHT_REASON = 'no_right'

export const QA_NAME_APPLICANT_TRANSITION_CONFIRMATION =
  'applicantTransitionConfirmation'

export const APPLICANT_CONFIRMED_TRANSITION = {
  [APPLICANT_REVEAL_IDENTITY_TRANSITION]: {
    action: APPLICANT_TRANSITION_ACTION.reveal,
    notificationKey:
      'RentalPortal.ApplicantProfileIdentityRevealedNotificationKey',
    submitKey: 'RentalPortal.ApplicantProfileRevealIdentityBtnKey',
    textKey: 'RentalPortal.ApplicantProfileRevealIdentityConfirmationTextKey',
    titleKey: 'RentalPortal.ApplicantProfileRevealIdentityConfirmationTitleKey',
  },
  [APPLICANT_STAGE.rejected]: {
    action: APPLICANT_TRANSITION_ACTION.reject,
    notificationKey: 'RentalPortal.ApplicantProfileRejectedNotificationKey',
    submitKey: 'RentalPortal.ApplicantProfileStageRejectBtnKey',
    textKey: 'RentalPortal.ApplicantProfileRejectConfirmationTextKey',
    titleKey: 'RentalPortal.ApplicantProfileRejectConfirmationTitleKey',
  },
  [APPLICANT_STAGE.withdrawn]: {
    action: APPLICANT_TRANSITION_ACTION.withdraw,
    notificationKey: 'RentalPortal.ApplicantProfileWithdrawnNotificationKey',
    submitKey: 'RentalPortal.ApplicantProfileStageWithdrawBtnKey',
    textKey: 'RentalPortal.ApplicantProfileWithdrawConfirmationTextKey',
    titleKey: 'RentalPortal.ApplicantProfileWithdrawConfirmationTitleKey',
  },
}
